import React from 'react';

import { notifyUnhandledLookupStatus } from 'connectors/bugsnag';

import InWarranty from './views/InWarranty';
import DifferentAccount from './views/DifferentAccount';
import SerialNumberNotFound from './views/SerialNumberNotFound';
import OutOfWarranty from './views/OutOfWarranty';
import PartNotEligible from './views/PartNotEligible';
import IncorrectPartNumber from './views/IncorrectPartNumber';
import {
  LOOKUP_UI_DIFFERENT_ACCOUNT_STATE,
  LOOKUP_UI_INITIAL_STATE,
  LOOKUP_UI_IN_WARRANTY_STATE,
  LOOKUP_UI_PART_NOT_ELIGIBLE_STATE,
  LOOKUP_UI_OUT_OF_WARRANTY_STATE,
  LOOKUP_UI_SN_NOT_FOUND_STATE,
  LOOKUP_UI_MULTIPLE_PARTS_STATE,
  LOOKUP_UI_INCORRECT_PART_STATE,
  LOOKUP_UI_INVALID_CONTRACT_STATE,
  LOOKUP_UI_RMA_FORBIDDEN_STATE,
  LOOKUP_UI_OOW_WITHOUT_PRICE_STATE,
  LOOKUP_UI_RMA_SCRAPPED_STATE,
} from 'utils/constants';
import SerialNumberLookup from './views/SerialNumberLookup';
import MultipleParts from './views/MultipleParts';
import InvalidContract from './views/InvalidContract';
import RmaForbiddenForPart from './views/RmaForbiddenForPart';
import OutOfWarrantyWithoutPrice from './views/OutOfWarrantyWithoutPrice';
import RmaScrapped from './views/RmaScrapped';

export const LookupView = ({ status, lookupResults }) => {
  switch (status) {
    case LOOKUP_UI_RMA_FORBIDDEN_STATE:
      return <RmaForbiddenForPart />;
    case LOOKUP_UI_MULTIPLE_PARTS_STATE:
      return <MultipleParts />;
    case LOOKUP_UI_INVALID_CONTRACT_STATE:
      return <InvalidContract />;
    case LOOKUP_UI_PART_NOT_ELIGIBLE_STATE:
      return <PartNotEligible />;
    case LOOKUP_UI_SN_NOT_FOUND_STATE:
      return <SerialNumberNotFound />;
    case LOOKUP_UI_DIFFERENT_ACCOUNT_STATE:
      return <DifferentAccount />;
    case LOOKUP_UI_OUT_OF_WARRANTY_STATE:
      return <OutOfWarranty />;
    case LOOKUP_UI_OOW_WITHOUT_PRICE_STATE:
      return <OutOfWarrantyWithoutPrice />;
    case LOOKUP_UI_IN_WARRANTY_STATE:
      return <InWarranty />;
    case LOOKUP_UI_INCORRECT_PART_STATE:
      return <IncorrectPartNumber />;
    case LOOKUP_UI_INITIAL_STATE:
      return <SerialNumberLookup />;
    case LOOKUP_UI_RMA_SCRAPPED_STATE:
      return <RmaScrapped />;
    default:
      notifyUnhandledLookupStatus(status, lookupResults);
      return <SerialNumberNotFound />;
  }
};
